<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pi_inoutno }}</em>
          </div>
        </div> -->
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pi_custname">
            <label class="weui-form-preview__label">{{
              customLabel.pi_custname || "客户名称"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.pi_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pi_contact">
            <label class="weui-form-preview__label">{{
              customLabel.pi_contact || "收货联系人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pi_contact }} {{ form.main.pi_tel }}
              <call-mobile :mobile="form.main.pi_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_address">
            <label class="weui-form-preview__label">{{
              customLabel.pi_address || "收货地址"
            }}</label>
            <span
              class="weui-form-preview__value"
              :class="{
                'weui-form-preview__value-icon': !!form.main.pi_address,
              }"
              >{{ form.main.pi_address }}
              <router-link
                v-if="form.main.pi_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.pi_address"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_payments">
            <label class="weui-form-preview__label">{{
              customLabel.pi_payments || "收款方式"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pi_payments }}
              <span v-if="form.main.pi_currency">{{
                form.main.pi_currency
              }}</span>
              <span v-if="form.main.pi_rate && form.main.pi_rate != 1"
                >/ {{ form.main.pi_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{
              customLabel.pi_date || "发货日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_date
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" />
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pd_pdno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pd_pocode">
              <label class="weui-form-preview__label">客户PO号</label>
              <span class="weui-form-preview__value">{{
                item.pd_pocode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_pocode">
              <label class="weui-form-preview__label">客户物料编号</label>
              <span class="weui-form-preview__value">{{
                item.pd_custprodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">产品名称</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">型号</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">规格</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_outqty">
              <label class="weui-form-preview__label">数量</label>
              <span class="weui-form-preview__value"
                >{{ item.pd_outqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <!-- <div class="weui-form-preview__item" slot="qty" v-if="item.qty">
              <label class="weui-form-preview__label">{{
                customLabel.qty || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.qty }} {{ item.productDTO.pr_unit_extra }}</span
              >
            </div> -->
            <div class="weui-form-preview__item" slot="pd_netprice">
              <label class="weui-form-preview__label">不含税单价(元)</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_netprice,'#,##0.####')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_sendprice">
              <label class="weui-form-preview__label">含税单价(元)</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_sendprice,'#,##0.####')
              }}</span>
            </div>
            <!-- <div class="weui-form-preview__item" slot="pd_price_extra" :hidden="!item.pd_price_extra">
              <label class="weui-form-preview__label">辅助单价(元)</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_price_extra,'#,##0.####')
              }}</span>
            </div> -->
            <div class="weui-form-preview__item" slot="pd_nettotal">
              <label class="weui-form-preview__label">不含税金额(元)</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_nettotal,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_ordertotal">
              <label class="weui-form-preview__label">价税合计(元)</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_ordertotal,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_prodcode">
              <label class="weui-form-preview__label">产品编号</label>
              <span class="weui-form-preview__value">{{
                item.pd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand">
              <label class="weui-form-preview__label">厂家/品牌</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_brand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">规格</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_packingwag">
              <label class="weui-form-preview__label">包装方式</label>
              <span class="weui-form-preview__value">{{
                item.pd_packingwag
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_piece">
              <label class="weui-form-preview__label">件数</label>
              <span class="weui-form-preview__value">{{
                item.pd_piece
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_auditbillqty">
              <label class="weui-form-preview__label">开票数量</label>
              <span class="weui-form-preview__value">{{
                item.pd_auditbillqty
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_auditbillamount">
              <label class="weui-form-preview__label">开票金额</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_auditbillamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_remark">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value">{{
                item.pd_remark
              }}</span>
            </div>
          <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
          v-model="item.pd_text1" slot="pd_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
          v-model="item.pd_text2" slot="pd_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
          v-model="item.pd_text3" slot="pd_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
          v-model="item.pd_text4" slot="pd_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
          v-model="item.pd_text5" slot="pd_text5" hidden="true" />
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_nettotal">
            <label class="weui-form-preview__label">不含税金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_nettotal
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_taxtotal">
            <label class="weui-form-preview__label">税额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_taxtotal
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_total">
            <label class="weui-form-preview__label">价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_total
            }}</span>
          </div>
        </custom-layout>
      </div>
    </div>
    <div
      class="footer-bar weui-dialog__ft"
       v-if="!readonly"
    >
      <!-- <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        @click="f_unaudit"
        >反审</a
      > -->
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        v-if="editable"
        @click="f_audit"
        >审核</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
    Collapse,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/sale/prodinout",
      statusField: "pi_statuscode",
      caller: "SaleOut",
      xtype: "sale-saleout-formpanel",
    };
  },
};
</script>